import { render, staticRenderFns } from "./achievement.vue?vue&type=template&id=b270722c"
import script from "./achievement.vue?vue&type=script&lang=js"
export * from "./achievement.vue?vue&type=script&lang=js"
import style0 from "./achievement.vue?vue&type=style&index=0&id=b270722c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports